import { Skeleton, SkeletonProps } from 'antd'
import styled from 'styled-components'

import { FadedDivider } from '../shared-components/FadedDivider'

import { BreadcrumbsItem, Header, HeaderItem } from './CorePageHeader'
import { CorePageLoading } from './CorePageLoading'
import { SIDE_WIDTH } from './CorePageSideNavWrapper'

const Side = styled.aside`
  grid-area: side;
  width: ${SIDE_WIDTH}px;
  height: 100vh;
  padding: 1.5rem;
  background: ${({ theme }) => theme.colour.neutral.white};
  flex-direction: column;
  display: none;

  ${({ theme }) => theme.media.md`
    display: flex;
  `}
`

const Main = styled.main`
  grid-area: content;
`

const Row = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 1rem;
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const Avatar = styled(Skeleton.Button).attrs({ active: true })`
  width: 40px !important;
  height: 40px !important;
  min-width: 0 !important;
  border-radius: ${({ theme }) => theme.borderRadius.small} !important;
`

const Input = styled(Skeleton.Input).attrs<
  { block?: boolean; active?: boolean } & SkeletonProps
>({
  active: true,
  block: true,
  size: 'small',
})`
  border-radius: ${({ theme }) => theme.borderRadius.small} !important;
  height: 1.5rem !important;
`

const ThinInput = styled(Input).attrs({ block: false })`
  height: 1rem !important;
`

const ShortInput = styled(Input).attrs({ block: false })`
  height: 40px !important;

  & > .ant-skeleton-input {
    min-width: 0 !important;
    max-width: 80px !important;
  }
`

const BreadcrumbSkeleton = styled(ThinInput)`
  margin-right: auto;
  margin-left: 1rem;
`

const Scroll = styled.div`
  flex-grow: 1;
  overflow: auto;
`

export const CorePageSkeleton = () => {
  return (
    <>
      <Side>
        <Row>
          <Avatar />
          <Input />
        </Row>
        <br />
        <br />
        <Scroll>
          <Column>
            <ThinInput />
            <Input />
            <Input />

            <br />

            <ThinInput />
            <Input />
            <Input />
            <Input />
            <Input />

            <br />

            <ThinInput />
            <Input />
            <Input />
            <Input />
          </Column>
        </Scroll>
        <FadedDivider />
        <Column>
          <Input />
          <Input />
        </Column>
      </Side>

      <Header>
        <BreadcrumbsItem>
          <BreadcrumbSkeleton />
        </BreadcrumbsItem>

        <HeaderItem>
          <ShortInput />
        </HeaderItem>

        <HeaderItem hideMobile>
          <ShortInput />
        </HeaderItem>

        <HeaderItem>
          <Avatar />
        </HeaderItem>
      </Header>

      <Main>
        <CorePageLoading showLogo />
      </Main>
    </>
  )
}
